module.exports = __webpack_public_path__ + "StackedBoxesUnbranded.4677f9a0eab86d1f75d40a1b7445128f.png";